import { ExceptionalDayService } from 'core/services/ExceptionalDay'

export const useEditExceptionalDay = () => {
  const updateExceptionalDay = async (exceptionalDay, exceptionalDayId) => ExceptionalDayService.update(exceptionalDay, exceptionalDayId)

  return {
    updateExceptionalDay
  }
}
